import React, { useEffect, useState } from 'react';

const Toaster = ({ message, image, onClose, isOpen }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        onClose();
      }, 5000);
    }, 8000);

    return () => {
      setFadeOut(false);
      clearTimeout(timer);
    };
  }, [onClose]);

  const darkStyle = 'dark:bg-neutral-800 dark:border-neutral-700 dark:text-white';
  const fadeOutStyle = fadeOut ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0';
  const animationStyle = 'transition-all duration-5000';
  const shapeStyle = 'max-w-md bg-white border border-gray-200 rounded-md shadow-lg';
  const stylingClasses = `${shapeStyle} ${darkStyle} ${animationStyle} ${fadeOutStyle}`;

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed top-4 left-0 w-full flex justify-center z-50">
      <div className={stylingClasses}>
        <div className="flex items-center p-4 gap-2.5">
          <div className="flex-shrink-0">
            <img className="h-6 w-6" src={image} alt="" />
          </div>
          <div>
            <h3 className="text-base font-medium text-gray-800 dark:text-white">
              {message}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toaster;
